export default __webpack_public_path__ + "static/media/franchini-modal.7671b0e5.jpg";